import { MultipleValueTextInput, CheckBoxStyled } from "@iventis/components";
import { AdditionalAttributeDataFormComponent } from "@iventis/datafield-editor/src/attribute-editor";
import { DataFieldType } from "@iventis/domain-model/model/dataFieldType";
import { EventBlockSystemDataFieldType } from "@iventis/domain-model/model/eventBlockSystemDataFieldType";
import { StyledFieldLabel } from "@iventis/styles";
import { Content } from "@iventis/translations";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { AdditionalDataFieldProperties } from "@iventis/types";
import { Autocomplete, TextField } from "@mui/material";
import React from "react";

export const ScheduleConfigDatafieldsAdditionalFormData: AdditionalAttributeDataFormComponent<AdditionalDataFieldProperties> = ({ attribute, updateAttribute }) => {
    const translate = useIventisTranslate();

    const onAllowedMetadataPropertiesChange = (values: string[]) => {
        // If the metadata property selected for customer idenitifer is removed then reset the customer identifier
        if (!values.includes(attribute.customerIdentifierName)) {
            updateAttribute((a) => ({ ...a, customerIdentifierName: undefined, allowedMetadataProperties: values }));
        } else {
            updateAttribute((a) => ({ ...a, allowedMetadataProperties: values }));
        }
    };

    return (
        <>
            {attribute.type === DataFieldType.List && (
                <>
                    <div className="input-margin-bottom" data-testid="metadata-properties">
                        <StyledFieldLabel>{translate(Content.map3.attributes.allowed_metadata_properties)}</StyledFieldLabel>
                        <MultipleValueTextInput<string>
                            selectedValues={attribute?.allowedMetadataProperties ?? []}
                            definedValues={false}
                            onChange={(value) => onAllowedMetadataPropertiesChange(value)}
                            sectionalMargin={false}
                        />
                    </div>
                    <div className="input-margin-bottom" data-testid="customer-identifier">
                        <StyledFieldLabel>{translate(Content.map4.attributes.customerIdentifier)}</StyledFieldLabel>
                        <Autocomplete
                            multiple={false}
                            options={attribute?.allowedMetadataProperties ?? []}
                            onChange={(_, value) => updateAttribute((a) => ({ ...a, customerIdentifierName: value }))}
                            value={attribute.customerIdentifierName ?? ""}
                            // eslint-disable-next-line react/jsx-props-no-spreading
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </div>
                </>
            )}
            <div className="input-margin-bottom tickbox-container" data-testid="required-tickbox">
                <CheckBoxStyled checked={attribute.required} onChange={() => updateAttribute((a) => ({ ...a, required: !a.required }))} />
                <StyledFieldLabel>{translate(Content.map3.attributes.required)}</StyledFieldLabel>
            </div>
            <div className="input-margin-bottom" data-testid="system-data-field">
                <StyledFieldLabel>{translate(Content.map3.attributes.system_datafield_type)}</StyledFieldLabel>
                <Autocomplete
                    multiple={false}
                    options={[EventBlockSystemDataFieldType.Code, EventBlockSystemDataFieldType.Style]}
                    value={attribute.systemDataField}
                    onChange={(_, value: EventBlockSystemDataFieldType) => updateAttribute((a) => ({ ...a, systemDataField: value }))}
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    renderInput={(params) => <TextField {...params} />}
                />
            </div>
            <div className="input-margin-bottom">
                <StyledFieldLabel>{translate(Content.map4.attributes.namingOrder)}</StyledFieldLabel>
                <TextField
                    value={attribute.namingOrder ?? ""}
                    onChange={(event) => {
                        updateAttribute((a) => ({ ...a, namingOrder: event.target.value?.length === 0 ? undefined : Number(event.target.value) }));
                    }}
                    type="number"
                    fullWidth
                />
            </div>
        </>
    );
};
